var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SiteLayout',[_c('router-view',{attrs:{"name":"site"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }